import {useAppSelector} from '../../store/store';
import styles from './header_dropdown.module.scss';
import navStyles from './../navigation/navigation.module.scss';
import {NavLink} from 'react-router-dom';
import {isAuthenticatedSelector} from '../../store/slices/exchange_token_slice.ts';
import React, {useCallback, useState} from 'react';
import {useClickOutside} from '../../support/use_click_outside.ts';
import {classNames} from '../../support/classnames.ts';
import {__} from '../../support/lang/translations.ts';
import {navLinkClass} from '../navigation/navigation.tsx';

export function HeaderDropdown() {
    const meInfo = useAppSelector((state) => state.customerInfo.me);
    const name = meInfo?.customer?.data?.find((d) => d?.key === 'name')?.value;
    const isAuthenticated = useAppSelector(isAuthenticatedSelector);

    const [isOpen, setIsOpen] = useState(false);

    const ref = React.useRef<HTMLDivElement | null>(null);
    const closePopupCallback = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    useClickOutside(ref, closePopupCallback);

    return (
        <div className={styles.header__dropdown} ref={ref}>
            <div
                className={classNames(styles.dropdown__toggle, {
                    [styles.open]: isOpen,
                })}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className={styles.toggle__avatar}>
                    {meInfo?.customer?.profilePicture?.signed_url != null ? (
                        <img
                            src={meInfo.customer.profilePicture.signed_url}
                            alt={`Image ${name}`}
                            onError={(e) => (e.currentTarget.style.display = 'none')}
                        />
                    ) : (
                        <span>{name?.substring(0, 1)}</span>
                    )}
                </div>
                <span
                    className={classNames(styles.avatar_arrow, {
                        [styles.arrow_open]: isOpen,
                    })}
                >
                    <i className="fa-light fa-chevron-down" />
                </span>
            </div>
            <div className={`${styles.dropdown__menu} ${isOpen ? styles.open : null}`}>
                {isAuthenticated ? (
                    <>
                        <NavLink to="profile" className={navLinkClass} onClick={() => setIsOpen(false)}>
                            <span className={navStyles.item__icon}>
                                <i className="fa-regular fa-user"></i>
                            </span>
                            <span className={navStyles.item__text}>{__('nav.dropdown.profile')}</span>
                        </NavLink>
                        <NavLink to="vehicles" className={navLinkClass} onClick={() => setIsOpen(false)}>
                            <span className={navStyles.item__icon}>
                                <i className="fa-light fa-car"></i>
                            </span>
                            <span className={navStyles.item__text}>{__('nav.dropdown.vehicles')}</span>
                        </NavLink>
                        <NavLink to="logout" className={navLinkClass} onClick={() => setIsOpen(false)}>
                            <span className={navStyles.item__icon}>
                                <i className="fa-light fa-power-off"></i>
                            </span>
                            <span className={navStyles.item__text}>{__('nav.dropdown.logout')}</span>
                        </NavLink>
                    </>
                ) : (
                    <NavLink to="login" className={navLinkClass}>
                        {__('nav.dropdown.login')}
                    </NavLink>
                )}
            </div>
        </div>
    );
}
